import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, CircularProgress,Box } from '@mui/material';
import Paging from './Paging';
import { fetchWithToken } from "../api/apiutils";

const UserFilterTable = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const rowsPerPage = 10;
  const { userId } = useParams();
  
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetchWithToken(`/api/filters/byUser?UserId=${userId}&page=${currentPage}&pageLimit=${rowsPerPage}`);
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const responseData = await response.json();
        const fetchedData = responseData.data || [];
        setData(fetchedData);
        setTotalRecords(responseData.totalRecords || fetchedData.length);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [userId, currentPage]);

  const totalPages = useMemo(() => Math.ceil(totalRecords / rowsPerPage), [totalRecords]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <Box>
      <TableContainer component={Paper} className='user-list-container'>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Дата</TableCell>
              <TableCell>Регион</TableCell>
              <TableCell>Текст</TableCell>
              <TableCell>Подписка</TableCell>
              <TableCell>Сумма</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((filter, index) => (
              <TableRow key={index}>
                <TableCell>{(currentPage - 1) * rowsPerPage + index + 1}</TableCell>
                <TableCell>{new Date(filter.dateOfCreation).toLocaleString()}</TableCell>
                <TableCell>{filter.regionCode}</TableCell>
                <TableCell>{filter.text}</TableCell>
                <TableCell>{filter.subscribe ? 'Да' : 'Нет'}</TableCell>
                <TableCell>{filter.amount}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Paging
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </Box>
  );
};

export default UserFilterTable;
